export default __webpack_public_path__ + "static/decathlonProLogoDesk-6a2d38b7817a26a8c36b1f2d246524b6.svg";